module.exports = __webpack_public_path__ + "static/media/Logo.ea51dbab.png";